module.exports = __webpack_public_path__ + "img/product_73.8094b79.webp";